import { FormattedMessage } from 'react-intl'
import Text from 'components/shared/Text'
import Info from 'components/shared/Info'
import { BirthdayUnlimitedPromotionInfoWrapper } from './styles'
import { darkMode } from 'styles/theme'

const BirthdayUnlimitedPromotionInfo = () => {
    const PromoInfo = (
        <Text variant="bodySmall" color="grayscale_400">
            <FormattedMessage
                id="promo.birthday.unlimited_discount_info_block"
                defaultMessage="Ceny kart obniżą się po podaniu kodu <span>URODZINY</span> w podsumowaniu zamówienia."
                description="Keep the html tags in the translation"
                values={{
                    span: (chunks: string[]) => (
                        <>
                            <Text
                                as="span"
                                variant="bodySmall"
                                color="primary_500"
                            >
                                {chunks}
                            </Text>
                        </>
                    ),
                }}
            />
        </Text>
    )

    return (
        <BirthdayUnlimitedPromotionInfoWrapper isFullWidth mb={24}>
            <Info
                color="info"
                hasNoBackground
                hasBorder
                theme={darkMode}
                align="center"
            >
                {PromoInfo}
            </Info>
        </BirthdayUnlimitedPromotionInfoWrapper>
    )
}

export default BirthdayUnlimitedPromotionInfo
